import React, { memo } from 'react'
import { makeStyles, createTheme } from 'transfix-ui/core'
import { rogersHeaderFontFamily } from 'transfix-ui/theme'
import { calcRem } from 'transfix-ui/theme/typography'

const usePopupTitleStyles = makeStyles(() => {
  const theme = createTheme()
  return {
    root: {
      fontFamily: rogersHeaderFontFamily,
      fontWeight: 600,
      letterSpacing: calcRem(0.15),
      fontSize: calcRem(24),
      lineHeight: calcRem(33),
      fontStyle: 'normal',

      [theme.breakpoints.up('md')]: {
        fontWeight: 500,
        fontSize: calcRem(20), // 20px
        lineHeight: calcRem(27),
      },
    },
  }
})

interface IPopupTitleProps {
  /**
   * @example 'Stop'
   */
  children: string
}

const PopupTitle = memo<IPopupTitleProps>(({ children }) => {
  const classes = usePopupTitleStyles()
  return <div className={classes.root}>{children}</div>
})

export default PopupTitle
